/* eslint-disable prettier/prettier */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../redux/configureStore';
import { getClientsBalance } from '../../../../../../redux/fetchActions/legadoPage/clientsApp';
import SearchButton from '../../../../../../shared/components/buttons/SearchButton';
import Filter from '../../../../../../shared/components/Filter';
import SetAccountType from './components/setAccountType';
import SetStatus from './components/SetStatus';
import SetPartner from './components/SetPartner';

export function ClientsFilter() {
  const dispatch = useDispatch();

  const clientsFilterState = useSelector(
    (reducer: IReducer) => reducer.clientsFilter
  );

  const profileNivelState = useSelector(
    (reducer: IReducer) => reducer.partnerProfile
  );

  function dispathData() {
    if (profileNivelState.nivel !== 2) {
      dispatch(
        getClientsBalance(
          profileNivelState.idLegado,
          clientsFilterState.account,
          clientsFilterState.initialDate,
          clientsFilterState.status,
          clientsFilterState.finalDate,
        )
      );
    } else {
      dispatch(
        getClientsBalance(
          clientsFilterState.partner,
          clientsFilterState.account,
          clientsFilterState.initialDate,
          clientsFilterState.status,
          clientsFilterState.finalDate,
        )
      );
    }
  }
 
  function searchFare() {
    return dispathData();
  }

  return (
    <Filter.Default>
      <SetPartner />
      <SetAccountType />
      <SetStatus />
      <SearchButton
        onClick={() => searchFare()}
        justifyContent="center"
        width="10rem"
      />
    </Filter.Default>
  );
}

export default ClientsFilter;
